// @flow

import React from 'react';
import styled from 'styled-components';
import type { Theme } from '../../../../types';

type ACFProps = {
  name: string,
  field_options: {
    label: string,
  },
};

const Divider = styled<any, Theme>('div')`
  margin-top: 2rem;
`;

const Title = styled<any, Theme>('h4')`
  font-size: 1.1rem;
  margin: 0 0 2rem 0;
`;

/*
  added the className .divider, the class is used in end-divider.
*/
export default ({ name, field_options }: ACFProps) => (
  <Divider className="divider">
    {field_options.label !== 'none' && (
      <Title>{name}</Title>
    )}
  </Divider>
);
